"use client";

import {Input} from "@heroui/input";
import {Link} from "@heroui/link";
import {Divider} from "@heroui/divider";

import React from "react";
import {Button} from "@heroui/button";
import {Bold} from "@/components/DownloaderApp/Bold";
import posthog from "posthog-js";
import {STARTER_PACK_PRICE, STARTER_PACK_DOWNLOAD_CREDITS} from "@/config/pricing";
// https://www.newskeeper.io/tools/youtube-rss?query=https%3A%2F%2Fwww.youtube.com%2F%40bigclivedotcom


const plans = [
    {
        title: <>{STARTER_PACK_DOWNLOAD_CREDITS} <Bold>Sub-only</Bold> VOD Download Credits</>,
        price: STARTER_PACK_PRICE,
        benefits: [
            <p>
                <Bold>Real Savings</Bold>: {STARTER_PACK_DOWNLOAD_CREDITS} Download Credits <Bold>=</Bold> access to {STARTER_PACK_DOWNLOAD_CREDITS} Subscription-Only / Private Kick.com VODs
            </p>,
            <p>
                <Bold>Zero Commitment</Bold>: One-time payment; no recurring fees
            </p>,
            <p>
                <Bold>Flexible</Bold>: Credits stay valid for 3 full months
            </p>,
            <p>
                <Bold>Fair Play</Bold>: Re-downloading the same video never costs extra
            </p>,
            <p>
                <Bold>VOD Player included</Bold>: no need to download whole content
            </p>
        ]
    }
]

export default function PricingPlansComponent() {

    function onCTAClicked() {
        if(process.env.NEXT_PUBLIC_ENFORCE_BUY_ME_A_COFFEE === 'true') {
            window.open('https://buymeacoffee.com/adasq/e/549358')
        } else {
            window.open('/api/stripe/checkout')
        }

        posthog.capture('UpsellPopup opened', {
            source: '/sub-only-download-credits'
        })
    }

    return <div className="flex justify-center my-12 gap-8">

        {
            plans.map((plan, index) => (
                <div key={index} className={"max-w-[520px] bg-gray-700 rounded-2xl flex flex-col px-8 py-10"}>
                    <h2 className={"text-3xl font-bold text-white"}>
                        {plan.title}
                    </h2>
                    <p className={"mt-2 text-gray-400"}>for <span>Subscription-Only</span> and <span>Private</span> Kick.com VODs</p>

                    <div className={"mt-5 flex gap-2 items-baseline"}>
                        <span className={"text-5xl font-bold"}>${plan.price}</span>
                        <span className={""}>/ <Bold>one-time</Bold> payment</span>
                    </div>

                    <Button className={"w-full my-5 text-md"} color={"primary"} onPress={onCTAClicked}>Get my credits</Button>
                    <Divider />
                    <ul>
                        {plan.benefits.map((item, i) => (
                            <li key={i} className={"flex items-center gap-2 mt-4"}>
                                <OutlineCheckCircle className={"min-w-[24px]"} />
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>
            ))
        }


    </div>;
};

export function OutlineCheckCircle(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24px"
            height="24px"
            {...props}
        >
            <path
                fill="currentColor"
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4l8-8z"
            ></path>
        </svg>
    )
}
